import { useState, useEffect } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Heading from './components/heading';
import ButtonGroup from './components/buttonGroup';
import Button from './components/button';
import Spinner from './assets/spinner';

function App() {
  const [isOpen, setIsOpen] = useState(false)
  const [prompt, setPrompt] = useState('')
  const [wordCounter, setWordCounter] = useState('0')
  const [isValidated, setIsValidated] = useState(false)
  const [content, setContent] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [copied, setCopied] = useState(false)
  const [downloaded, setDownloaded] = useState(false)
  const [cleared, setCleared] = useState(false)

  useEffect(() => {

    if (prompt === '') {
      setWordCounter(0);
    } else {
      setWordCounter(prompt.trim().split(' ').length)
    }

  }, [prompt]);

  useEffect(() => {

    if ( 50 < wordCounter && wordCounter <= 400 ) {
      setIsValidated(true)
    } else {
      setIsValidated(false)
    }

  }, [wordCounter])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if(wordCounter <= 50) {
      toast('Text must be at least 50 words')
      setIsOpen(false)
    } 
      else if ( 50 < wordCounter && wordCounter <= 400 ) {
        try {
          setIsLoading(true)
          setIsOpen(true)
          
          const requestOption = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ prompt }),
          }
          const response = await fetch('/summarize', requestOption)

          if(response.ok) {
            const data = await response.json()
            const { content } = data

            setContent(content)
          } else {
            console.error('error occured with status code:', response.status)
          }

        } catch (error) {
          console.error(error)
        } finally {
          setIsLoading(false)
        }

    } else {
      toast('Text must be less than 400 words')
      setIsOpen(false)
    }
 
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(content)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 5000)
  }

  const handleDownload = () => {

    const file = new Blob([content], {type: 'text/plain'})

    const element = document.createElement("a")
    element.href = URL.createObjectURL(file)
    element.download = "summarized-text" + Date.now() + ".txt"

    document.body.appendChild(element)
    element.click()

    setDownloaded(true)
    setTimeout(() => {
      setDownloaded(false)
    }, 5000)
  }

  const handleClear = () => {
    setContent('')

    setCleared(true)
    setTimeout(() => {
      setCleared(false)
    }, 5000)
  }

  return (
    <div className="h-auto container mx-auto pt-16 flex justify-center items-center max-[320px]:pt-0 md:h-full md:pt-0">
      <div className="grid grid-cols-12 gap-5 w-full">
        <header className="col-span-12 md:mb-2 lg:mb-4">
          <div className="flex flex-col gap-4 md:flex-row md:items-end justify-center">
            <h1 className="text-5xl font-medium">
              AI Text Summarizer
            </h1>
          </div>
        </header>
        <main className="col-span-12"> 
          <div className="flex flex-col gap-6 lg:flex-row">
            <div className="card">
              <form
                onSubmit={handleSubmit} 
                className="h-full"
              >
                <Heading 
                h3='Summarizer'
                >
                  <p className="md:mr-4">
                    <span 
                      className={`
                      ${isValidated && isValidated ? 
                      'text-black' : 
                      'text-red-500'}
                       text-xl`
                      }>{wordCounter}
                    </span> Words
                  </p>
                </Heading>
                <textarea 
                  name="prompt"
                  className="card__content outline-none resize-none" 
                  placeholder="Enter text here"
                  value={prompt}
                  onChange={e => setPrompt(e.target.value)}
                >
                </textarea>
                <ButtonGroup>
                  <button 
                    type="submit"
                    className="w-full font-bold text-2xl no-underline"
                  >
                    Summarize
                  </button>
                  <ToastContainer />
                </ButtonGroup>
              </form>
            </div>
            <div className={`${ isOpen ? 'block mb-16' : 'hidden' } card md:block md:mb-0`}>
                <Heading 
                  h3='Summarized Text'
                />
                <div className="card__content overflow-y-scroll relative">
                  { isLoading && isLoading ? <Spinner /> : null }
                  { content && <p>{content}</p>}
                </div>
                <ButtonGroup styles="justify-between items-center">
                  <Button 
                    icon="📑"
                    styles="border-r"
                    content={!copied ? "Copy" : "Copied"}
                    onClick={handleCopy}
                  />
                  <Button 
                    icon="⏬"
                    content={!downloaded ? "Download" : "Downloaded"}
                    onClick={handleDownload}
                  />
                  <Button 
                    icon="🗑️"
                    styles="border-l"
                    content={!cleared ? "Clear" : "Cleared"}
                    onClick={handleClear}
                  />
                </ButtonGroup>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
